import { RatingBoardsView } from './RatingBoardsView';

/**
 * The **Ratings** section — §9.1, parallel to Leaderboards and deliberately not inside it. They
 * answer different questions, and nesting one implies a rating is a view of a board, which is the
 * misconception §1 exists to prevent.
 *
 * <h3>This was two tabs for one release, and is now one thing</h3>
 *
 * `RatingGroup` — the older tag-filtered grouping, which had no scoring at all: its recalculation
 * only ever stamped a timestamp, which is the gap this feature closes — shared this section under
 * a **Tag groups** tab while both existed. §13 retired it at Phase 4b, exactly as the switcher was
 * put here to allow: the second tab goes, this file renders the boards under the heading, and
 * nothing else moves. Every group a room had was converted to a board by the migration.
 *
 * The frame stays here rather than moving into `RatingBoardsView`. That component is the list and
 * the standings behind it; the page's title and the sentence distinguishing a rating from a
 * leaderboard belong to the section, and a future second thing in here — §9.2's builder is Phase
 * 6 — goes beside the list rather than inside it.
 */
export function RatingsView() {
  return (
    <div className="p-8">
      <div className="mb-6">
        <h1 className="font-display text-2xl font-semibold text-ink-950">Player ratings</h1>
        <p className="mt-1 max-w-2xl text-sm text-ink-800/60">
          How good a player is, as distinct from who won a series. A rating looks back over a
          rolling window and weights recent results more heavily than old ones, so it moves with the
          calendar as well as with the results.
        </p>
      </div>

      <RatingBoardsView />
    </div>
  );
}
